require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/fn/is-iterable.js
// module id = 957
// module chunks = 0 1